import React, { useEffect, useState } from "react";
import axios from "axios";
import { OnlineStatusContext } from "./OnlineStatusContext";

function OnlineOfflineSwitcher({ pollingUrl, children }) {
  console.log("OnlineOfflineSwitcher", "pollingUrl", pollingUrl);
  console.log("OnlineOfflineSwitcher", "isOnline", navigator.onLine);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isPollingSuccessful, setIsPollingSuccessful] = useState(false);

  useEffect(() => {
    const updateOnlineStatus = () => {
      console.log("OnlineOfflineSwitcher", "updateOnlineStatus", navigator.onLine);
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    if (isOnline) {
      const poll = () => {
        axios
          .get(pollingUrl)
          .then(() => setIsPollingSuccessful(true))
          .catch(() => setIsPollingSuccessful(false));
      };

      poll();
      const intervalId = setInterval(poll, 5000);

      return () => clearInterval(intervalId);
    }
  }, [isOnline, pollingUrl]);

  return (
    <OnlineStatusContext.Provider value={{ isOnline: isOnline && isPollingSuccessful }}>
      {children}
    </OnlineStatusContext.Provider>
  );
}

export default OnlineOfflineSwitcher;
